<style scoped lang="less">
.map { width: 100%;height:400px;}
.ol-tooltip {position: relative;background: rgba(0, 0, 0, 0.5);border-radius: 4px;color: white;padding: 4px 8px;opacity: 0.7;white-space: nowrap;font-size: 12px;cursor: default;user-select: none;}
.ol-tooltip-measure { opacity: 1;font-weight: bold;}
.ol-tooltip-static {background-color: #ffcc33; color: black;border: 1px solid white;}
.ol-tooltip-measure:before,.ol-tooltip-static:before {border-top: 6px solid rgba(0, 0, 0, 0.5);border-right: 6px solid transparent;border-left: 6px solid transparent;content: "";position: absolute;bottom: -6px; margin-left: -7px; left: 50%;}
/deep/.ol-tooltip-static:before {border-top-color: #ffcc33;}
/deep/.ol-selectable> .ol-tooltip{color: #fff;}
</style>

<template>
  <div>
  </div>
</template>

<script>
import 'ol/ol.css'
import Draw from 'ol/interaction/Draw'
import Overlay from 'ol/Overlay'
import CircleStyle from 'ol/style/Circle'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'
import LineString from 'ol/geom/LineString'
import Polygon from 'ol/geom/Polygon'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import {getArea, getLength} from 'ol/sphere'
import {unByKey} from 'ol/Observable'
let draw // global so we can remove it later
export default {
  data()
  {
    return {
      measureAry: []
    }
  },
  mounted()
  {
    document.oncontextmenu = function()
    {
      return false
    }
  },
  methods:
  {
    measure(map, typeSelect)
    {
      //清除测量标记
      if (typeSelect === 'delete')
      {
        this.measureAry.forEach(e =>
        {
          e.getSource().clear()
        })
        //清除测量结果
        let tagging = document.getElementsByClassName('ol-tooltip')
        for (let i = 0; i < tagging.length; i++)
          tagging[i].style.display = 'none'
        return
      }
      const source = new VectorSource()
      const vector = new VectorLayer({
        source: source,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 2
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33'
            })
          })
        })
      })
      this.measureAry.push(vector)
      /**
       * 目前绘制功能.
       * @type {import("../src/ol/Feature.js").default}
       */
      let sketch
      /**
       * 帮助工具提示元素。
       * @type {HTMLElement}
       */
      let helpTooltipElement
      /**
       * 覆盖显示帮助信息。
       * @type {Overlay}
       */
      let helpTooltip
      /**
       * 测量工具提示元素。
       * @type {HTMLElement}
       */
      let measureTooltipElement
      /**
       * 覆盖显示测量值。
       * @type {Overlay}
       */
      let measureTooltip
      /**
       * 消息显示用户正在绘制多边形。
       * @type {string}
       */
      /**
       * 消息，以显示用户何时正在绘制一条线。
       * @type {string}
       */
      /**
       * Handle pointer move.
       * @param {import("../src/ol/MapBrowserEvent").default} evt The event.
       */
      const pointerMoveHandler = function(evt)
      {
        if (evt.dragging)
          return
        /** @type {string} */
        let helpMsg = '点击开始绘图'
        helpTooltipElement.innerHTML = helpMsg
        helpTooltip.setPosition(evt.coordinate)
        helpTooltipElement.classList.remove('hidden')
      }
      map.addLayer(vector)
      map.on('pointermove', pointerMoveHandler)
      map.getViewport().addEventListener('mouseout', function()
      {
        helpTooltipElement.classList.add('hidden')
      })
      let seft = this
      /**
       * 格式输出长度.
       * @param {LineString} line The line.
       * @return {string} The formatted length.
       */
      const formatLength = function(line)
      {
        var sourceProj = map.getView().getProjection()//获取投影坐标系
        const length = getLength(line, {projection: sourceProj})
        let output
        if (length > 100)
          output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km'
        else
          output = Math.round(length * 100) / 100 + ' ' + 'm'
        seft.$store.commit('onMeasureNum', output)
        return output
      }
      /**
       * 格式输出
       * @param {Polygon} polygon The polygon.
       * @return {string} Formatted area.
       */
      const formatArea = function(polygon)
      {
        var sourceProj = map.getView().getProjection()//获取投影坐标系
        const area = getArea(polygon, {projection: sourceProj})
        let output
        if (area > 10000)
          output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>'
        else
          output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>'
        seft.$store.commit('onMeasureNum', output)
        return output
      }
      function addInteraction()
      {
        //开始选择绘制类型之前取消上次选择类型
        map.removeInteraction(draw)
        const type = typeSelect === 'area' ? 'Polygon' : 'LineString'
        draw = new Draw({
          source: source,
          type: type,
          style: new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.7)'
            }),
            stroke: new Stroke({
              color: '#ffcc33',
              lineDash: [10, 10],
              width: 2
            }),
            image: new CircleStyle({
              radius: 5,
              stroke: new Stroke({
                color: 'rgba(255, 255, 255, 0.7)'
              }),
              fill: new Fill({
                color: 'rgba(255, 255, 255, 0.7)'
              })
            })
          })
        })
        map.addInteraction(draw)
        createMeasureTooltip()
        createHelpTooltip()
        let listener
        draw.on('drawstart', function(evt)
        {
          //开始绘制时，设置当前结果颜色
          measureTooltipElement.style.color = '#ffcc33'
          //开始绘制时，设置提示颜色
          helpTooltipElement.style.color = '#ffcc33'
          sketch = evt.feature
          /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
          let tooltipCoord = evt.coordinate
          listener = sketch.getGeometry().on('change', function(evt)
          {
            const geom = evt.target
            let output
            if (geom instanceof Polygon)
            {
              output = formatArea(geom)
              tooltipCoord = geom.getInteriorPoint().getCoordinates()
            }
            else if (geom instanceof LineString)
            {
              output = formatLength(geom)
              tooltipCoord = geom.getLastCoordinate()
            }
            seft.$store.commit('onMeasureNum', output)
            measureTooltipElement.innerHTML = output
            measureTooltip.setPosition(tooltipCoord)
          })
        })
        draw.on('drawend', function()
        {
          //右键确认时设置当前当算量算结果的颜色
          measureTooltipElement.style.color = '#FFCC33'
          measureTooltip.setOffset([0, -7])
          // 未设置的草图
          sketch = null
          // 取消设置工具提示以便创建新的工具提示
          measureTooltipElement = null
          createMeasureTooltip()
          unByKey(listener)
          map.un('pointermove', pointerMoveHandler)
          map.removeInteraction(draw)
          helpTooltipElement.classList.add('hidden')
          //画完线后清空提示
          helpTooltipElement.innerHTML = ''
        })
      }
      /**
       * 创建一个新的帮助提示
       */
      function createHelpTooltip()
      {
        if (helpTooltipElement)
          helpTooltipElement.parentNode.removeChild(helpTooltipElement)
        helpTooltipElement = document.createElement('div')
        helpTooltipElement.className = 'ol-tooltip hidden'
        helpTooltip = new Overlay({
          element: helpTooltipElement,
          offset: [15, 0],
          positioning: 'center-left'
        })
        map.addOverlay(helpTooltip)
      }
      /**
       * 创建一个新的度量工具提示
       */
      function createMeasureTooltip()
      {
        if (measureTooltipElement)
          measureTooltipElement.parentNode.removeChild(measureTooltipElement)
        measureTooltipElement = document.createElement('div')
        measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure'
        measureTooltip = new Overlay({
          element: measureTooltipElement,
          offset: [0, -15],
          positioning: 'bottom-center',
          stopEvent: false,
          insertFirst: false
        })
        map.addOverlay(measureTooltip)
      }
      addInteraction()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Measure.vue